import {
  mapInvoicePrintSettingsToUI,
  INVOICE_PRINT_DEFAULTS,
  type AppConfigRow,
  type InvoicePrintLogoSource,
  type InvoicePrintSettingsRow,
  type InvoicePrintSettingsUI,
} from '@helios/data-access';
import { orgLogoUrl, orgLogoHorizontalUrl } from '../../../shell/shared';
import { makePrintStyles, PAGE_STYLES } from '../prescription-print/print-utils';

/**
 * Scoped print stylesheet for the invoice surface. Shares the
 * `body[data-print-target=…]` scoping pattern with prescription print so the
 * two can co-exist on the same page (e.g. encounter accordion mode) without
 * stylesheet conflicts when only one is being printed.
 */
export const INVOICE_PRINT_STYLES = `${PAGE_STYLES}\n${makePrintStyles('invoice', 'ip-print-only')}`;

/**
 * Build the effective `InvoicePrintSettingsUI` from the saved org-default row,
 * falling back to `app_config` branding + defaults when the wizard hasn't been
 * run yet. The wizard preview and the live "Print Invoice" action both use
 * this so a clinic that has only configured app_config can still produce a
 * usable printout.
 */
export function resolveInvoicePrintSettings(
  savedRow: InvoicePrintSettingsRow | null,
  appConfig: AppConfigRow | null,
): InvoicePrintSettingsUI {
  if (savedRow) return mapInvoicePrintSettingsToUI(savedRow);

  const defaultLogoSource: InvoicePrintLogoSource = orgLogoUrl
    ? 'standard'
    : orgLogoHorizontalUrl
      ? 'horizontal'
      : 'none';

  return {
    id: '',
    ...INVOICE_PRINT_DEFAULTS,
    logoSource: defaultLogoSource,
    clinicName: appConfig?.org_name ?? '',
    clinicAddress: appConfig?.org_address ?? '',
    clinicPhone: appConfig?.org_phone ?? '',
    clinicEmail: appConfig?.org_email ?? '',
  };
}
